import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Upload } from 'antd';
import './UploadBox.scss';
import { useState } from 'react';
import { UploadFile } from 'antd/lib/upload/interface';

const { Dragger } = Upload;

interface UploadBoxProps {
  height?: number;
  handleUpload: (files: UploadFile[]) => Promise<void>;
}

/**
 * A component that allows users to upload files
 *
 * @param {Object} props - Component properties.
 * @param {number} props.height - The height of the upload box.
 * @param {Function} props.handleUpload - The function to handle the upload of files.
 * @return {ReactNode} The rendered component.
 */
export default function UploadBox({ height, handleUpload }: UploadBoxProps): JSX.Element {
  const [errorMessage, setErrorMessage] = useState('');

  /**
   * Props for the ant design upload 'Dragger' component.
   */
  const uploadFileProps: UploadProps = {
    name: 'hk_asset_media',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file, fileList) => {
      setErrorMessage('');
      handleUpload([file]).then((_r) => {}).catch((error) => {
        console.error('Upload error:', error);
        setErrorMessage('Error uploading files. Please try again.');
      });
      return false;
    }
  };

  return (
    <>
      <Dragger height={height || 115} className={`upload-file`} {...uploadFileProps}>
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text">
          Drag and Drop media here or choose file
        </p>
      </Dragger>
      {errorMessage && <div className="upload-error">{errorMessage}</div>}
    </>
  );
}
